import PropTypes from 'prop-types';
import React, {useContext} from 'react';
import { TextAlignLeftRenderer, TextRenderer, CheckboxIconRenderer } from "../SmartTableRenderers";
import {SQLIndex} from "../../fms.core/constants";
import ApplicationContext from "../../ApplicationContext";
import LookupField from "../../ui/lookup/LookupField";
import {CompanyLookupProps} from "./CompanyLookupField";
import {LookupCompany} from "../../fms.data/lookup";
import CheckBox from "../../ui/CheckBox";

interface SkuLookupProps extends Omit<Omit<CompanyLookupProps, 'initialValue'>, 'onSelect'> {
  onSelect: (x: LookupCompany|LookupCompany[]) => void,
  fetchAddress: boolean,
  isMultiple: boolean,
  initialValue?: string|null|undefined,
  multiSelectValues?: LookupCompany[],
  formPara?: string,
  formPara2?: string,
  addFirmsCode?: boolean,
  opType?: string|null,
  isMultiRptOption?: boolean,
  //isMultipleSelected?: boolean,
}

const CompanyListExLookupField = ({
  initialValue = '',
  onSelect = () => {},
  placeholder = undefined,
  onTextChange = () => {},
  disabled = false,
  lookupId = undefined,
  onTabNext = undefined,
  onTabPrevious = undefined,
  companyItems = undefined,
  onFocus = () => {},
  onBlur = () => {},
  focusableWhenDisabled = false,
  fetchAddress = false,
  isMultiple = false,
  multiSelectValues = [],
  noBorder = false,
  filterName = '',
  formPara = '',
  formPara2 = '',
  opType = '',
  addFirmsCode = false,
  isMultiRptOption = false,
  //isMultipleSelected = false,
  ...others
}: SkuLookupProps) => {
  
  const isMultipleSelected= Array.isArray(multiSelectValues) && multiSelectValues.length > 0

  const changeSelected = (checked: boolean, selected: LookupCompany) => {
    if (checked) {
      if(!Array.isArray(multiSelectValues)) {
        multiSelectValues = []; 
      }
      onSelect([...multiSelectValues, selected])
    } else {
      onSelect([...multiSelectValues.filter(item => item.id !== selected.id)])
    }
  }

  const additionalColumns = [];
  if (isMultiple) {
    additionalColumns.push({
      Header: '',
      accessor: 'select',
      resizable: true,
      sortable: false,
      canBeHidden: false,
      visible: true,
      width: 20,
      Cell: ({row}: any) => {
        return <div style={{display: 'block', width: '100%'}}>
            <CheckBox value={Array.isArray(multiSelectValues) && !!multiSelectValues?.find(item => item.id === row.original.id)}
                      onChange={(checked) => changeSelected(checked, row.original)}/>
        </div>
      }
    })
  }
  const additionalColumns1 = [];
  if (addFirmsCode) {
    additionalColumns1.push({ Header: 'FIRMS Code', accessor: 'iataNo', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 80, Cell: TextRenderer })
  }

  const inactiveColumns = [];
  if (formPara2 === 'IncludeInactive') {
    inactiveColumns.push({
      Header: 'InActive',
      accessor: 'inActive',
      resizable: true,
      sortable: false,
      canBeHidden: false,
      visible: true,
      width: 50,
      Cell: CheckboxIconRenderer
    })
  }

  const columns = [
    ...additionalColumns,
    { Header: 'Company Name(Short Name)', accessor: 'shortName', resizable: false, sortable: false, canBeHidden: false, visible: true, width: formPara2 === 'IncludeInactive' ? (isMultiple ? 330 : 350) : (isMultiple ? 340 : 330), Cell: TextAlignLeftRenderer },
    { Header: 'Contact', accessor: 'contact', resizable: false, sortable: false, canBeHidden: false, visible: true, width: formPara2 === 'IncludeInactive' ? 130 : 150, Cell: TextAlignLeftRenderer },
    { Header: 'TEL', accessor: 'tel', resizable: false, sortable: false, canBeHidden: false, visible: true, width: formPara2 === 'IncludeInactive' ? 100 : 120, Cell: TextAlignLeftRenderer },
      ...inactiveColumns,
      ...additionalColumns1,
  ]

  const columnsForFullName = [
    ...additionalColumns,
    { Header: 'Company Name(Short Name)', accessor: 'shortName', resizable: false, sortable: false, canBeHidden: false, visible: true, width: formPara2 === 'IncludeInactive' ? (isMultiple ? 250 : 270) : (isMultiple ? 260 : 280), Cell: TextAlignLeftRenderer },
    { Header: 'Full Name', accessor: 'fullName', resizable: false, sortable: false, canBeHidden: false, visible: true, width: formPara2 === 'IncludeInactive' ? (isMultiple ? 120 : 140) : (isMultiple ? 130 : 150), Cell: TextAlignLeftRenderer },
    { Header: 'Contact', accessor: 'contact', resizable: false, sortable: false, canBeHidden: false, visible: true, width: formPara2 === 'IncludeInactive' ? 72 : 92, Cell: TextAlignLeftRenderer },
    { Header: 'TEL', accessor: 'tel', resizable: false, sortable: false, canBeHidden: false, visible: true, width: formPara2 === 'IncludeInactive' ? 70 : 190, Cell: TextAlignLeftRenderer },
      ...inactiveColumns,
      ...additionalColumns1,
  ]

  const columnsWithFirmsCode = [
    { Header: 'Company Name(Short Name)', accessor: 'shortName', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 230, Cell: TextAlignLeftRenderer },
    { Header: 'Contact', accessor: 'contact', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 150, Cell: TextAlignLeftRenderer },
    { Header: 'Tel', accessor: 'tel', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 120, Cell: TextAlignLeftRenderer},
    { Header: 'FIRMS Code', accessor: 'iataNo', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 80, Cell: TextRenderer },
  ]


  const appContext = useContext(ApplicationContext);

  async function queryCompanies(queryString: string | null) {
    const apiResult = await appContext.api.getLookupItems(SQLIndex.CompanyListEx, queryString || '', (filterName === 'fullName' ? 'FullName' : formPara || ''), formPara2 || '', (addFirmsCode ? 'FirmsCode' : ''));
    // return apiResult?.data?.entities || [];
    return apiResult?.entities || [];
  }

  async function _onSelect(x: LookupCompany) {
    if(!isMultiple) {
      if(fetchAddress) {
        const apiResult = await appContext.api.getAddressFromCompanyFile(x.id, false, true, true, true, true, false, false);
        onSelect({...x, addr: apiResult})
      }else{
        onSelect(x)
      }
    } else if (isMultiple && isMultiRptOption && !isMultipleSelected){
        onSelect(x)
    }
  }

  function onCancel() {
  }

  function filter(data: Array<LookupCompany>, filterText: string) {
    return data.filter(x => addFirmsCode ? x.shortName && x.shortName.toLowerCase().startsWith(filterText.toLowerCase()) || x.iataNo && x.iataNo.toLowerCase().startsWith(filterText.toLowerCase()) : x.shortName && x.shortName.toLowerCase().startsWith(filterText.toLowerCase()));
  }

  return (
    <LookupField
      lookupId={lookupId}
      onTabNext={onTabNext}
      onTabPrevious={onTabPrevious}
      disabled={disabled}
      query={queryCompanies}
      width={filterName === 'fullName' ? (addFirmsCode ? '709px' : '629px') : 
        (addFirmsCode ? (formPara2 === 'IncludeInactive' ? '727px' : '699px') : (formPara2 === 'IncludeInactive' || isMultiple ? '647px' : '617px'))}
      columns={(filterName === 'fullName' ? columnsForFullName : columns)}
      onSelect={_onSelect}
      onCancel={onCancel}
      labelProp={filterName}
      initialValue={initialValue}
      placeholder={placeholder}
      onTextChange={onTextChange}
      filter={filter}
      onBlur={onBlur}
      onFocus={onFocus}
      focusableWhenDisabled={focusableWhenDisabled}
      isMultiple={isMultiple}
      noBorder={noBorder}
      isMultipleSelected={isMultipleSelected}
      isMultiRptOption={isMultiRptOption}
      {...others}
    />
  );
}

CompanyListExLookupField.defaultProps = {
  onSelect: () => {},
  onTextChange: () => {},
  filterName: 'shortName',
  disabled: false,
  focusableWhenDisabled: false,
  fetchAddress: false,
  isMultiple: false,
  noBorder: false,
  formPara: '',
  formPara2: '',
  formPara3: '',
  formPara4: '',
  addFirmsCode: false,
};

CompanyListExLookupField.propTypes = {
  initialValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  filterName: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  lookupId: PropTypes.string,
  onTabNext: PropTypes.func,
  onTabPrevious: PropTypes.func,
  companyItems: PropTypes.array,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  focusableWhenDisabled: PropTypes.bool.isRequired,
  fetchAddress: PropTypes.bool,
  isMultiple: PropTypes.bool,
  noBorder: PropTypes.bool,
  formPara: PropTypes.string,
  formPara2: PropTypes.string,
  formPara3: PropTypes.string,
  formPara4: PropTypes.string,
  addFirmsCode: PropTypes.bool,
};


export default React.memo(CompanyListExLookupField);
